export default __webpack_public_path__ + "static/media/4d.0954d0ca.png";